<template>
    <div class="tsa-AgreementPreviewDialog" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <img src="@/assets/images/close.png" class="close" @click="close" alt="">
            <iframe :src="url" frameborder="0"></iframe>
        </div>
    </div>
</template>

<script>
import TsaButton from '@/components/copyright/basics/button' 
export default {
    components: {
        TsaButton
    },
    data () {
        return {
            show: false,
            url: ''
        }
    },
    methods: {
        close () {
            this.show = false
        }
    }
}
</script>

<style lang="scss" scoped>
    .tsa-AgreementPreviewDialog {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9;
        .mask {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 1;
            -webkit-backdrop-filter: blur(4px);
            backdrop-filter: blur(4px);
            background: rgba(0,0,0,0.65);
        }
        .content {
            position: absolute;
            width: 100%;
            height: 92%;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 2;
            display: flex;
            flex-direction: column;
            padding-top: .9rem;
            background: #FFFFFF;
            .close {
                position: absolute;
                width: .6rem;
                height: .6rem;
                top: .16rem;
                right: .16rem;
            }
            iframe {
                width: 100%;
                flex: 1;
                
            }
        }
    }
</style>